import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Error = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const errorMessage = searchParams.get('message') || 'An unknown error occurred';
  
  return (
    <div className="error-container">
      <h1>Authentication Error</h1>
      <div className="error-message">
        <p>{errorMessage}</p>
      </div>
      <Link to="/" className="back-link">
        Back to Home
      </Link>
    </div>
  );
};

export default Error; 